import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import LayoutChauffeur from '../LayoutChauffeur/LayoutChauffeur'
import { useParams } from 'react-router'
import { getMission } from '../../api/commande'
import AutocompleteAddress from '../GooglePlacesAutoComplete/AutocompleteAddress'
import { updateCommandeWayPoints, getPointsPassageForMission, sendSMSMission, reorderWaypoints } from '../../api/commande'
import 'react-phone-input-2/lib/style.css'
import toast from 'react-hot-toast'
import WaypointManagementCard from '../PointsPassages/WaypointManagementCard'
import { GradientText, StyledInput } from '../../Containers/PasserCommande/PasserCommande.styles'
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ActionModal from '../ValidationModal/ActionModal'
import { convertMinutesToHHMM } from '../../utils/formatters'
import ReorderModal from '../PointsPassages/ReorderWaypoint'
import { useTranslation } from "react-i18next";

function TransportTracking() {
	const { id } = useParams()
	const history = useHistory()
	const token = useSelector((state) => state.auth.token);
	const [chargementEnCours, setChargementEnCours] = useState(false)
	const [loading, setLoading] = useState(false)
	const [mission, setMission] = useState(null)
	const [place, setPlace] = useState(null)
	const [places, setPlaces] = useState([])
	const [totalDistance, setTotalDistance] = useState(0)
	const [modalIsOpenSendSMS, setModalIsOpenSendSMS] = useState(false)
	const [modalIsOpenSendMail, setModalIsOpenSendMail] = useState(false)
	const [loadingSendSMS, setLoadingSendSMS] = useState(false)
	const [phone, setPhone] = useState("")
	const [totalHeuresPlaces, setTotalHeuresPlaces] = useState('')
	const [totalForfait, setTotalForfait] = useState(0)
	const [dureeMission, setDureeMission] = useState(0);
	const [depassementHeures, setDepassementHeures] = useState(0)
	const [depassementKilometrage, setDepassementKilometrage] = useState(0)
	const [chargement, setChargement] = useState(false)
	const [isReorderModalVisible, setIsReorderModalVisible] = useState(false);
	const handleOpenReorderModal = () => setIsReorderModalVisible(true);
	const handleCloseReorderModal = () => setIsReorderModalVisible(false);
	const [selectedPlace, setSelectedPlace] = useState(null);
	const{t} = useTranslation();
    
	const fetchMissionWithLoading = async () => {
		setChargementEnCours(true);
		try {
			const mission = await getMission(id, token);
			const res = await getPointsPassageForMission(id, token)

			setMission(mission);
			setPlaces(res.pointsPassages)
		} catch (err) {
			console.log('error', err)
		} finally {
			setChargementEnCours(false);
		}
	}

	const fetchMission = async () => {
		try {
			const resulta = await getPointsPassageForMission(id, token)
			setTotalForfait(resulta.mission.total_kilometrage)
			setDureeMission(resulta.mission.duree_mission)
			setMission(resulta.mission);
			setPlaces(resulta.pointsPassages)
			setTotalHeuresPlaces(resulta.mission.total_horaire_parcouru)
			setTotalDistance(resulta.mission.total_kilometrage_parcouru)
			setDepassementHeures(resulta.mission.depassement_horaire)
			setDepassementKilometrage(resulta.mission.depassement_kilometrage)
		} catch (err) {
			console.log('error', err)
		}
	}

	const handleReorder = async (waypointId, newPosition) => {
		try {
			const data = {
				waypointId: waypointId,
				newPosition, newPosition
			}
			const response = await reorderWaypoints(mission?._id, data, token);
			toast.success(response.message, {
				style: {
					fontFamily: 'Montserrat',
				},
			})
			await fetchMission()
		} catch (error) {
			console.error("Erreur lors du réordonnancement", error);
			toast.error(
				error.response?.data?.message ||
				error.response?.data?.error ||
				t("error_updating_location"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			handleCloseReorderModal();
		}
	};










	useEffect(() => {
		fetchMissionWithLoading()
	}, [id])

	useEffect(() => {
		fetchMission()
	}, [chargement])




	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);
	return (
		<LayoutChauffeur>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<div
						onClick={() => {
							history.goBack()
						}}
						style={{
							background: '#51C7F2',
							width: isSmallScreen ? '1.5rem' : '2.5rem',
							height: isSmallScreen ? '1.5rem' : '2.5rem',
							borderRadius: '100%',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
						}}
					>
						<svg xmlns='http://www.w3.org/2000/svg' width={14.017} height={14.11} viewBox='0 0 14.017 14.11'>
							<g data-name='Group 11287' fill='none' stroke='#fff' strokeWidth={2}>
								<path data-name='Path 11687' d='M16.6 11.818l-6.348 6.349 2.115 2.115 4.232 4.232' transform='translate(-8.838 -11.113)' />
								<path data-name='Path 11688' d='M22.147 11.818l-6.348 6.349 6.348 6.348' transform='translate(-8.838 -11.113)' />
							</g>
						</svg>
					</div>

					<div
						style={{
							width: '1rem',
						}}
					/>

					<GradientText marginTop={'unset'} style={{
						fontSize: isSmallScreen ? '1.5rem' : '2.5rem'
					}}>
						{t("stop_point").toUpperCase()}
					</GradientText>
				</div>
				{chargementEnCours ?
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: "3rem",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,

						}}
					>
						<div className='customLoader'></div>
					</div>
					:
					<div
						style={{

							width: '100%',
							fontFamily: 'Montserrat',
							marginBottom: '2rem',
							marginTop: '1rem',
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'space-between',

						}} >

						<p style={{ width: '100%', fontSize: '16px' }}>
							<b>
								{`${t("package")} ${totalForfait} km ${t("for")} ${convertMinutesToHHMM(dureeMission)}`}
							</b>
						</p>

						<div
							style={{
								background: '#f8f9fa',
								borderRadius: '10px',
								padding: '2rem',
								marginBottom: '5rem',
								boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
								width: '100%',
								display: 'flex',
								flexDirection: isSmallScreen ? 'column' : 'row',
								alignItems: 'flex-start'

							}}
						>

							{(!mission?.signé && mission?.statut === "en-cours") &&
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										marginBottom: '2rem',
										width: isSmallScreen ? '100%' : '70%',

									}}
								>
									<span
										style={{
											marginBottom: '1rem',
											color: '#495057',
											fontSize: '14px',
											fontWeight: 'bold',
										}}
									>
										{t("add_address")}
									</span>
									<AutocompleteAddress
										onPlaceSelect={(placeDetails) => {
											console.log('Place ID:', placeDetails.place_id);
											console.log('Description:', placeDetails.description);
										}}
										onValueChange={async (selectedValue) => {
											if (selectedValue) {
												setPlace(selectedValue);
											}
										}}
										value={place}
										style={{
											marginBottom: '1rem',
										}}
										placeholder = {t("enter_european_location")}
									/>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}>
										<button
											disabled={loading}
											onClick={async () => {
												if (place) {
													setLoading(true);
													try {
														await updateCommandeWayPoints(
															id,
															{
																adresse: place
															},
															token
														);
														fetchMission();
													} catch (error) {
														toast.error(error.response.data.message, {
															style: {
																fontFamily: 'Montserrat',
															},
														});
													}
													setLoading(false);
													setPlace(null)
												}
											}}
											style={{
												marginTop: '1rem',
												background: '#50F5A9',
												padding: '1rem 2rem',
												color: 'white',
												borderRadius: 5,
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'center',
												cursor: 'pointer',
												fontWeight: 'bold',
												border: 'none',
												width: isSmallScreen ? '100%' : "200px",
												height: "50px",
											}}
										>
											{loading ? <div className='loader'></div> : t("add")}
										</button>
									</div>
								</div>
							}
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									flex: 1,
									padding: '1rem',
									background: '#ffffff',
								}}
							>
								<p style={{ margin: 0, padding: 0 }}>
									<b>
										<span>Total Km : </span>
										<span style={{ color: 'crimson' }}>
											{totalDistance?.toFixed(2)} Km
										</span>
									</b>
									<br />
									<b>
										<span>{t("total_time")} : </span>
										<span style={{ color: 'crimson' }}>
											{convertMinutesToHHMM(totalHeuresPlaces)}
										</span>
									</b>
									<br />
									<b>
										{t("excess")} Km :{' '}
										<span style={{ color: 'crimson' }}>
											{depassementKilometrage}
											Km
										</span>
									</b>
									<br />
									<b>
										{t("overtime")}  :{' '}
										<span style={{ color: 'crimson' }}>
											{convertMinutesToHHMM(depassementHeures)}

										</span>
									</b>
									<br />
								</p>
							</div>




						</div>

						{places.map((place, index) => (
							<WaypointManagementCard
								key={index}
								place={place}
								index={index}
								setChargement={setChargement}
								commandeID={mission?.commande?._id}
								onReorder={() => {
									setSelectedPlace(place)
									handleOpenReorderModal()
								}}
							/>
						))}

						<div
							style={{
								width: "100%",
								background: mission?.signé ? '#E6F7FF' : '#E4EAF0',
								display: 'flex',
								flexDirection: 'column',
								padding: '1rem',
								borderRadius: 10,
								alignItems: 'flex-start',
								justifyContent: 'space-between',
								marginTop: '4rem',
								marginBottom: 10,
							}}
						>

							<div
								style={{
									display: "flex",
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '1rem',
									fontFamily: 'Montserrat',
									width: '100%'

								}}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
										marginRight: '1rem',

									}}
								>
									<span
										style={{
											marginBottom: '.5rem',
											color: 'black',
											fontSize: 13,


										}}
									>
										{t("nom_signataire")}
									</span>


									<StyledInput

										disabled={true}
										type="text"
										value={mission?.commande?.nom_signataire
										}
									/>


								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
										marginRight: '1rem',
										marginTop: isSmallScreen ? '1rem' : 0,

									}}
								>
									<span
										style={{
											marginBottom: '.5rem',
											color: 'black',
											fontSize: 13,


										}}
									>
										{t("prénom_signataire")}
									</span>


									<StyledInput

										disabled={true}
										type="text"
										value={mission?.commande?.prénom_signataire
										}
									/>


								</div>

							</div>
							<div
								style={{
									display: "flex",
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '1rem',
									fontFamily: 'Montserrat',
									width: '100%'

								}}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
										marginRight: '1rem',

									}}
								>
									<span
										style={{
											marginBottom: '.5rem',
											color: 'black',
											fontSize: 13,


										}}
									>

										{t("signatory_phone_number1")}
									</span>

									<PhoneInput
										country='fr'
										placeholder=''
										value={mission?.commande?.téléphone1_signataire}
										disabled={true}

										inputStyle={{
											paddingRight: '1.5rem',
											paddingTop: '1.5rem',
											paddingBottom: '1.5rem',
											borderRadius: '0.5rem',
											border: 'none',
											fontFamily: 'Montserrat',
											color: '#858ea8',
											flex: '1',
											display: 'flex',
											width: '100%'

										}}


										buttonStyle={{

											borderRadius: '0.5rem',
											border: 'none',
											fontFamily: 'Montserrat',
											color: '#858ea8',
											flex: '1',
											display: 'flex'
										}}

									/>


								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
										marginRight: '1rem',
										marginTop: isSmallScreen ? '1rem' : 0,

									}}
								>
									<span
										style={{
											marginBottom: '.5rem',
											color: 'black',
											fontSize: 13,


										}}
									>

										{t("signatory_phone_number2")}
									</span>

									<PhoneInput
										country='fr'
										placeholder=''
										value={mission?.commande?.téléphone2_signataire}
										disabled={true}

										inputStyle={{
											paddingRight: '1.5rem',
											paddingTop: '1.5rem',
											paddingBottom: '1.5rem',
											borderRadius: '0.5rem',
											border: 'none',
											fontFamily: 'Montserrat',
											color: '#858ea8',
											flex: '1',
											display: 'flex',
											width: '100%'

										}}


										buttonStyle={{

											borderRadius: '0.5rem',
											border: 'none',
											fontFamily: 'Montserrat',
											color: '#858ea8',
											flex: '1',
											display: 'flex'
										}}

									/>


								</div>

							</div>
							{!mission?.signé &&
								<div
									style={{
										display: "flex",
										flexDirection: isSmallScreen ? 'column' : 'row',
										marginBottom: '1rem',
										width: '100%'

									}}>

									<button
										onClick={async (e) => {
											e.preventDefault()
											setPhone(mission?.commande?.téléphone1_signataire)
											setModalIsOpenSendSMS(true)

										}}
										style={{
											padding: '1rem 2rem',
											mariginLeft: "1rem",
											background: '#60d2f8',
											border: 'none',
											cursor: 'pointer',
											color: 'white',
											borderRadius: 7,
											fontFamily: 'Montserrat',
											fontWeight: 'bold',
											marginRight: '1rem',
											marginTop: '1rem',
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											height: "50px",
										}}>
										{t("send_code_by_sms")}
									</button>
									<button
										onClick={async (e) => {
											e.preventDefault()
											setPhone(mission?.commande?.téléphone2_signataire)
											setModalIsOpenSendSMS(true)

										}}
										style={{
											padding: '1rem 2rem',
											mariginLeft: "1rem",
											background: '#60d2f8',
											border: 'none',
											cursor: 'pointer',
											color: 'white',
											borderRadius: 7,
											fontFamily: 'Montserrat',
											fontWeight: 'bold',
											marginRight: '1rem',
											marginTop: '1rem',
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											height: "50px",
										}}>
										{t("send_code_by_sms")}
									</button>
								</div>
							}
							<div
								style={{
									display: "flex",
									flexDirection: isSmallScreen ? 'column' : 'row',
									marginBottom: '1rem',
									fontFamily: 'Montserrat',
									width: '100%'

								}}>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										width: isSmallScreen ? '100%' : '50%',
										marginRight: '1rem',
										marginBottom: '0.5rem'
									}}
								>
									<span
										style={{
											marginBottom: '.5rem',
											color: 'black',
											fontSize: 13,


										}}
									>

										{t("signatory_email")}
									</span>
									<StyledInput

										disabled={true}
										type="text"
										value={mission?.commande?.email_signataire
										}
									/>



								</div>
								{!mission?.signé &&
									<button
										onClick={() => {
											setModalIsOpenSendMail(true)

										}}
										style={{
											padding: '1rem 2rem',
											mariginLeft: "1rem",
											background: '#60d2f8',
											border: 'none',
											cursor: 'pointer',
											color: 'white',
											borderRadius: 7,
											fontFamily: 'Montserrat',
											fontWeight: 'bold',
											marginRight: '1rem',
											marginTop: '1.5rem',
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											justifyContent: 'center',
											alignItems: 'center',
											height: "50px",
										}}>
										{t("send_code_by_email")}
									</button>
								}
							</div>



							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									width: isSmallScreen ? '100%' : '60%',
								}}
							>
								<span
									style={{
										marginBottom: '.5rem',
										color: 'black',
										fontSize: 13,
										fontFamily: 'Montserrat',

									}}
								>
									{t("signed")}
								</span>

								<div
									className='radio-btn-group-palettes'
									style={{
										display: 'flex',
										flexDirection:'row',
										marginBottom: '0.5rem',
										
									}}>
									<div
										className='radio'
										style={{
											marginRight: '1rem',
										}}
									>
										<button
											disabled={true}
											style={{
												background: mission?.signé ? '#fcc200' : '#fff',
												border: '1px solid #ddd',
												borderColor: mission?.signé && '#fcc200',
												padding: ' 0.5rem 1.25rem',
												borderRadius: '5px',
												cursor: 'pointer',
												color: mission?.signé ? '#fff' : '#444',
												
											}}
										>{t("yes")}</button>


									</div>
									<div

										style={{
											marginRight: '1rem',
										}}
									>
										<button
											disabled={true}
											style={{
												background: !mission?.signé ? '#fcc200' : '#fff',
												border: '1px solid #ddd',
												borderColor: !mission?.signé && '#fcc200',
												padding: ' 0.5rem 1.25rem',
												borderRadius: '5px',
												cursor: 'pointer',
												color: !mission?.signé ? '#fff' : '#444',
												
											}}
										>{t("no")}</button>
									</div>
								</div>

							</div>
						</div>
					</div>
				}

			</div>

			{/* Reorder Modal */}
			<ReorderModal
				visible={isReorderModalVisible}
				onClose={handleCloseReorderModal}
				onReorder={handleReorder}
				currentIndex={place?.position}
				places={places}
				currentPlaceId={selectedPlace?._id}
				currentPosition={selectedPlace?.position}
			/>

			<ActionModal
				isOpen={modalIsOpenSendMail}
				onRequestClose={() => { }}
				title={t("send_code")}
				message={t("send_code_confirmation")}
				onConfirm={async () => {
					setLoadingSendSMS(true)
					try {
						const res = await sendSMSMission({ "missionId": mission?._id, "method": 'email', email: mission?.commande?.email_signataire }, token)
						toast.success(res.message, {
							style: {
								fontFamily: 'Montserrat',
							},
						})
					} catch (error) {
						toast.error(error.response?.data?.message || t("error_while_sending_signature_code"), {
							style: {
								fontFamily: 'Montserrat',
							},
						});
					} finally {
						setModalIsOpenSendMail(false)
						setLoadingSendSMS(false)
					}

				}}

				onCancel={() => {
					setModalIsOpenSendMail(false)
				}}
				isLoading={loadingSendSMS}
			/>
			<ActionModal
				isOpen={modalIsOpenSendSMS}
				onRequestClose={() => { }}
				title={t("send_code")}
				message={t("send_code_confirmation")}
				onConfirm={async () => {
					setLoadingSendSMS(true)
					try {
						const res = await sendSMSMission({ "numero": phone, "missionId": mission?._id, "method": 'sms' }, token)
						toast.success(res.message, {
							style: {
								fontFamily: 'Montserrat',
							},
						})
					} catch (error) {
						toast.error(t("transfer_request_err"), {
							style: {
								fontFamily: 'Montserrat',
							},
						})
					} finally {
						setModalIsOpenSendSMS(false)
						setLoadingSendSMS(false)
					}
				}}

				onCancel={() => {
					setModalIsOpenSendSMS(false)
				}}
				isLoading={loadingSendSMS}
			/>
		</LayoutChauffeur>

	)

}

export default TransportTracking
